import { render } from "./StatsCustoms.vue?vue&type=template&id=c59a72f0&scoped=true"
import script from "./StatsCustoms.vue?vue&type=script&lang=ts"
export * from "./StatsCustoms.vue?vue&type=script&lang=ts"

import "./StatsCustoms.vue?vue&type=style&index=0&id=c59a72f0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c59a72f0"

export default script